"use client"
import {ContainerDetailComponent} from "@/core/general/container/containerDetail.component";
import {FC, PropsWithChildren, Suspense, useEffect} from "react";
import {Provider} from "react-redux";
import {store} from "@/core/redux/store";
import {Loader} from "@/core/general/ui/loader.component";

interface containerProps {
    hasResponsivePadding?: boolean;
    onSettingClick?: any;
}

export const ContainerComponent: FC<PropsWithChildren<containerProps>> = (props) => {

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            if (typeof window !== 'undefined')
                window.addEventListener('load', function () {
                    navigator.serviceWorker.register('/sw.js', {scope: '/'}).then(
                        function (registration) {
                            console.log('Service Worker registration successful with scope: ', registration.scope);
                        },
                        function (err) {
                            console.log('Service Worker registration failed: ', err);
                        }
                    );
                });
        }
    }, []);

    return (
            <Provider store={store}>
                <Suspense fallback={<Loader isFullScreen={false}/>}>
                    <ContainerDetailComponent hasResponsivePadding={props.hasResponsivePadding} onSettingClick={props.onSettingClick}>
                        {props.children}
                    </ContainerDetailComponent>
                </Suspense>
            </Provider>
    );
};
